import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Moon } from 'lucide-react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  onCtaClick: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-120">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-121" />

      <FadeIn delay={0.1} data-id="element-122">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 text-amber-300 text-sm font-medium mb-8 border border-amber-500/20" data-id="element-123">
          <Moon className="w-4 h-4" data-id="element-124" />
          <span data-id="element-125">Protocolo Nocturno de 5 Minutos</span>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-126">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-6 leading-tight" data-id="element-127">
          Tu Cerebro No Tiene Botón de OFF <br className="hidden md:block" data-id="element-128" />
          <span className="text-amber-400" data-id="element-129">(Pero Este Protocolo Sí)</span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-130">
        <p className="text-xl md:text-2xl text-stone-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-131">
          Vacíe su ansiedad nocturna, silencie la rumiación y recupere su sueño
          sin meditaciones guiadas ni fármacos.
        </p>
      </FadeIn>

      <FadeIn delay={0.35} data-id="element-132">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 4,
        ease: 'easeInOut'
      }} className="mx-auto mb-12 relative max-w-[320px] md:max-w-[400px] perspective-[1000px]" data-id="element-133">
          <motion.img whileHover={{
          rotateY: -5,
          rotateX: 5,
          scale: 1.02
        }} transition={{
          duration: 0.4
        }} src="https://cdn.magicpatterns.com/uploads/4e7Y8xZzsUzCFT6eNbfD2g/ChatGPT_Image_18_abr_2026,_17_52_08.png" alt="Mente en Blanco Ebook Cover" className="w-full h-auto rounded-md shadow-[0_20px_50px_-12px_rgba(217,119,6,0.3)] border border-stone-800/50" style={{
          transformStyle: 'preserve-3d'
        }} data-id="element-134" />
        </motion.div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-135">
        <div className="bg-stone-900/50 border border-stone-800 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-12 text-left shadow-xl" data-id="element-136">
          <p className="text-stone-300 text-lg leading-relaxed italic" data-id="element-137">
            <span className="text-amber-400 font-semibold not-italic" data-id="element-138">
              Son las 11:45 PM.
            </span>{' '}
            Apagas la luz, cierras los ojos y, en lugar de descanso, comienza el
            desfile. Correos que no enviaste, esa conversación incómoda de la
            tarde, el miedo sutil a no rendir mañana si no te duermes YA. Tu
            cuerpo está agotado, pero tu mente está encendida, repasando una
            lista interminable de "pendientes invisibles".
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-139">
        <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8 py-6 h-auto rounded-full shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] transition-all hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:scale-105" onClick={onCtaClick} data-id="element-140">
          Descargar el Protocolo Ahora
        </Button>
      </FadeIn>
    </section>;
}